import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default class CheckinRoute extends Route {
  model() {}

  setupController(controller /*, model*/) {
    const application = this.controllerFor('application');
    controller.loadDataTask.perform();
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
  }
}
